import { Layout } from 'layout/layout'
import { AboutUsSection } from 'components/sections/aboutUs'
import { HowItWorksSection } from 'components/sections/howItWorks'
import { ContactUsSection } from 'components/sections/contactUs'
// import { ReviewsSection } from 'components/sections/reviews'
import { HomeHead } from 'pages/home/homeHead'

const Home = () => {
  return (
    <Layout>
      <HomeHead />
      <HowItWorksSection shifted />
      {/* <ReviewsSection /> */}
      <AboutUsSection />
      <ContactUsSection />
    </Layout>
  )
}

export default Home
